import styles from "./registration-complete.module.scss";
import { LOGIN_ROUTE } from "@/routing/app-routes";
import { useNavigate } from "react-router-dom";
import CenteredContent from "@/components/common/layouts/centered-content/centered-content";
import { useTranslation } from "react-i18next";
import SecondaryButton from "@/components/common/buttons/secondary-button/SecondaryButton";
import PrimaryButton from "@/components/common/buttons/primary-button/PrimaryButton";
import useSendVerificationEmail from "@/api/routes/users/verification-email";
import { useGlobalToastStore } from "@/state/toast-store";
import { parseApiErrorIntoMessage } from "@/api/utils";
import { TOAST_TYPES } from "@/components/common/toasts/toast-constants";
import { useAuth } from "@/api/auth/AuthProvider";

const RegistrationComplete = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const addToast = useGlobalToastStore((state) => state.addToast);
  const { t } = useTranslation();

  const { mutate: sendVerificationEmail, isPending } = useSendVerificationEmail(
    {
      onSuccess: () => {
        addToast({
          message: t("emailSentSuccessfully"),
          type: TOAST_TYPES.SUCCESS,
        });
      },
      onError: (error) => {
        addToast({
          message: parseApiErrorIntoMessage(error),
          type: TOAST_TYPES.ERROR,
        });
      },
    }
  );

  const executeResendEmail = () => {
    sendVerificationEmail(user);
  };

  if (!user) return null;

  return (
    <CenteredContent
      title={t("registrationComplete")}
      subTitle={
        <div className="flex column align-center">
          <div className={`${styles.subMessage} mb-1`}>
            {t("registrationCompleteSubtitle", {
              email: user.email,
            })}
          </div>
          <div className={styles.subMessage}>
            {t("registrationCompleteTimeout")}
          </div>
        </div>
      }
    >
      <div className={`flex between col-gap-4 mt-4 ${styles.buttonContainer}`}>
        <SecondaryButton
          text={t("back")}
          onClick={() => {
            navigate(LOGIN_ROUTE);
          }}
        />
        <PrimaryButton
          text={t("sendLinkAgain")}
          onClick={executeResendEmail}
          disabled={isPending}
        />
      </div>
    </CenteredContent>
  );
};

export default RegistrationComplete;
